import api from '@Services/api';
import { AxiosResponse } from 'axios';
import { Content } from '../Types/WebContent.types';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from '@Base/services/services.base';

export class WebContentRequester implements CRUDBase<Content, Content> {
	public static instance: WebContentRequester = new WebContentRequester();
	baseURL = 'webContent/';
	getAll(payload?: GetAllMeta): Promise<AxiosResponse<ApiResponse<Content[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<Content[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Content[]>>> {
		return await api.post(`${this.baseURL}fetch`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<Content>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<Content>>>;
	get(
		id: string | number,
		payload?: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Content>>>;
	async get(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Content>>> {
		return await api.post(`${this.baseURL}get`, { id });
	}
	async create(
		payload: Omit<Content, 'id'>
	): Promise<AxiosResponse<ApiResponse<Content>>> {
		return await api.post(`${this.baseURL}create`, payload);
	}
	async update(payload: Content): Promise<AxiosResponse<ApiResponse<Content>>> {
		return await api.post(`${this.baseURL}update`, payload);
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload?: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<any>>> {
		throw new Error('Method not implemented.');
	}
}
